import { render, staticRenderFns } from "./lenovoPartCode.vue?vue&type=template&id=aa2603d8&scoped=true&"
import script from "./lenovoPartCode.vue?vue&type=script&lang=js&"
export * from "./lenovoPartCode.vue?vue&type=script&lang=js&"
import style0 from "./lenovoPartCode.vue?vue&type=style&index=0&id=aa2603d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2603d8",
  null
  
)

export default component.exports